/**
 * Access — per-user page permissions (sales + admin staff) and role builder.
 */
import { useState } from 'react';
import { Users, ShieldCheck, UserCog } from 'lucide-react';
import Permissions from './Permissions';
import Roles from './Roles';

const TABS = [
    { id: 'sales', label: 'Sales users', icon: Users },
    { id: 'admin', label: 'Admin users', icon: UserCog },
    { id: 'roles', label: 'Roles', icon: ShieldCheck },
];

export default function Access() {
    const [tab, setTab] = useState('sales');

    return (
        <div className="space-y-4">
            <div>
                <h1 className="text-2xl font-extrabold">Access &amp; Permissions</h1>
                <p className="text-sm text-ink-500">
                    Set page access per sales or admin user, or build roles with default permissions.
                </p>
            </div>

            <div className="flex flex-wrap gap-1 border-b border-ink-100">
                {TABS.map(({ id, label, icon: Icon }) => (
                    <button
                        key={id}
                        type="button"
                        onClick={() => setTab(id)}
                        className={`px-5 py-3 text-sm font-semibold border-b-2 transition flex items-center gap-2 -mb-px
                        ${tab === id ? 'border-brand-teal text-brand-teal-700' : 'border-transparent text-ink-500 hover:text-ink-900'}`}
                    >
                        <Icon className="h-4 w-4" />
                        {label}
                    </button>
                ))}
            </div>

            <div>
                {tab === 'sales' && <Permissions key="sales" audience="sales" />}
                {tab === 'admin' && <Permissions key="admin" audience="admin" />}
                {tab === 'roles' && <Roles />}
            </div>
        </div>
    );
}
